import { render, staticRenderFns } from "./InventoryPageHeader.vue?vue&type=template&id=736bd024&scoped=true"
var script = {}
import style0 from "./InventoryPageHeader.vue?vue&type=style&index=0&id=736bd024&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736bd024",
  null
  
)

export default component.exports